import cart from './categories/cart';
import cartCustom from './categories/cart-custom';
import cartLine from './categories/cart-line';
import kpi from './categories/kpi';
import map from './categories/map';
import qa from './categories/qa';
import settins from './categories/settins';

export default {
  ...cart,
  ...cartCustom,
  ...cartLine,
  ...kpi,
  ...map,
  ...qa,
  ...settins
}